import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';

import { config } from '../../shared/smartadmin.config';
import { Observable } from 'rxjs/Observable';
import { Console } from '@angular/core/src/console';

@Injectable()
export class ValuacionApiService {
  data: any[] = [];

  valuacionURL: string = config.API_DATA_URL + "/valuacion";

  constructor(public http: HttpClient) {}

  public getValuacionData(idOS): Observable<any> {
    const headers = this.getHeaders();

    return this.http
      .get(this.valuacionURL + "/GetValuacion/" + idOS, { headers })
      .map((response: any) => {
        this.data = response;
        return this.data;
      })
      .catch(this.handleError);
  }

  public AgregarDetalle(valuacion: any) {
    const headers = this.getHeaders();
    const param = JSON.stringify(valuacion);
    return this.http
      .post(this.valuacionURL + "/AgregarDetalle", param, { headers })
      .map((resultado: any) => {
        return resultado;
      })
      .catch((error: any) => {
        return Observable.throw(new Error(error.status));
      });
  }

  public ActualizarComentario(valuacion: any) {
    const headers = this.getHeaders();
    const param = JSON.stringify(valuacion);
    return this.http
      .post(this.valuacionURL + "/ActualizarComentario", param, { headers })
      .map((resultado: any) => {
        return resultado;
      })
      .catch((error: any) => {
        return Observable.throw(new Error(error.status));
      });
  }

  public ActualizarDetalle(valuacion: any) {
    const headers = this.getHeaders();
    const param = JSON.stringify(valuacion);
    return this.http
      .post(this.valuacionURL + "/ActualizarDetalle", param, { headers })
      .map((resultado: any) => {
        return resultado;
      })
      .catch((error: any) => {
        return Observable.throw(new Error(error.status));
      });
  }

  public EliminarDetalle(valuacion: any) {
    const headers = this.getHeaders();
    const param = JSON.stringify(valuacion);
    return this.http
      .post(this.valuacionURL + "/EliminarDetalle", param, { headers })
      .map((resultado: any) => {
        return resultado;
      })
      .catch((error: any) => {
        return Observable.throw(new Error(error.status));
      });
  }

  public AceptarValuacion(valuacion: any) {
    const headers = this.getHeaders();
    const param = JSON.stringify(valuacion);
    return this.http
      .post(this.valuacionURL + "/Aceptar", param, { headers })
      .map((resultado: any) => {
        return resultado;
      })
      .catch((error: any) => {
        return Observable.throw(new Error(error.status));
      });
  }

  public SubirDetalle(id: number) {
    const headers = this.getHeaders();
    const param = JSON.stringify(id);
    return this.http
      .post(this.valuacionURL + "/SubirDetalle", param, { headers })
      .map((resultado: any) => {
        return resultado;
      })
      .catch((error: any) => {
        return Observable.throw(new Error(error.status));
      });
  }

  public BajarDetalle(id: number) {
    const headers = this.getHeaders();
    const param = JSON.stringify(id);
    return this.http
      .post(this.valuacionURL + "/BajarDetalle", param, { headers })
      .map((resultado: any) => {
        return resultado;
      })
      .catch((error: any) => {
        return Observable.throw(new Error(error.status));
      });
  }

  private getBaseUrl() {
    return (
      location.protocol +
      "//" +
      location.hostname +
      (location.port ? ":" + location.port : "") +
      "/"
    );
  }

  private getHeaders(): HttpHeaders {
    const headers = new HttpHeaders({
      "Content-Type": "application/json",
    });

    return headers;
  }

  private handleError(error: any) {
    // In a real world app, we might use a remote logging infrastructure
    // We'd also dig deeper into the error to get a better message
    const errMsg = error.message
      ? error.message
      : error.status
        ? `${error.status} - ${error.statusText}`
        : "Server error";
    console.error(errMsg); // log to console instead
    return Observable.throw(errMsg);
  }
}



// WEBPACK FOOTER //
// C:/Users/stivens/Lab/sonever/repos/taller-web/src/app/core/api/valuacion-api.service.ts